import { API } from "revolt.js";
import styles from "./Attachment.module.scss";
import classNames from "classnames";
import { useState } from "preact/hooks";

import { useClient } from "../../../../controllers/client/ClientController";
import { selectImageViewer } from "./image-modal.helper";

enum ImageLoadingState {
    Loading,
    Loaded,
    Error,
}

type Props = JSX.HTMLAttributes<HTMLImageElement> & {
    attachment: API.File;
    allAttachments?: (API.File | API.Embed)[];
    height: number;
    width: number;
};

export default function ImageFile({
    attachment,
    allAttachments,
    width,
    height,
    ...props
}: Props) {
    const [loading, setLoading] = useState(ImageLoadingState.Loading);
    const client = useClient();
    const url = client.generateFileURL(attachment)!;
    const metadata =
        attachment.metadata.type === "Image" ? attachment.metadata : undefined;

    let aspectRatio = 0;
    if (metadata) {
        aspectRatio = metadata.width / metadata.height;
    } else {
        aspectRatio = width / height;
    }
    return (
        <div
            style={{
                width,
                height,
            }}>
            <img
                {...props}
                src={url}
                alt={attachment.filename}
                // Это свойство не нужно потому что виртуозо и так лениво
                // все подгружает и с ним неприятно из за этого выглядит все
                // loading="lazy"
                // width={metadata?.width}
                style={{
                    aspectRatio,
                    maxWidth: width,
                    maxHeight: height,
                }}
                // height={metadata?.height}
                className={classNames(styles.image, {
                    [styles.loading]: loading !== ImageLoadingState.Loaded,
                })}
                onClick={() => selectImageViewer(allAttachments, attachment)}
                onMouseDown={(ev) =>
                    ev.button === 1 && window.open(url, "_blank")
                }
                onLoad={() => setLoading(ImageLoadingState.Loaded)}
                onError={() => setLoading(ImageLoadingState.Error)}
            />
        </div>
    );
}
